import { useCallback, useEffect } from 'react';

import {
  modalSubject,
  paywallSubject,
  personalizedReadingHubSubject,
  stickyBannerBottomSubject,
} from '@utils/blueconic/constants';
import { AnyBlueconicEvent } from '@utils/blueconic/eventsInterfaces';
import { verifyBlueconicDialogue } from '@utils/blueconic/verifyDialogue';

const useBlueconicEvent = () => {
  const handleBlueconicEvent = useCallback((_event: string, data: AnyBlueconicEvent) => {
    if (!data) {
      return;
    } else {
      verifyBlueconicDialogue(data);
    }
  }, []);

  useEffect(() => {
    const subscribeToEvent = () => {
      window.blueConicClient?.event?.subscribe('propertiesDialogue', this, handleBlueconicEvent);
    };

    // This is to ensure that blueConicClient is loaded before subscribing to the event
    // Reference: https://support.blueconic.com/hc/en-us/articles/202605221-JavaScript-front-end-API
    if (
      typeof window.blueConicClient !== 'undefined' &&
      typeof window.blueConicClient.event !== 'undefined' &&
      typeof window.blueConicClient.event.subscribe !== 'undefined'
    ) {
      subscribeToEvent();
    } else {
      window.addEventListener('onBlueConicLoaded', subscribeToEvent, false);
    }
    return () => {
      window.blueConicClient?.event?.unsubscribe('propertiesDialogue');
      window.removeEventListener('onBlueConicLoaded', subscribeToEvent);
      modalSubject.unsubscribe();
      paywallSubject.unsubscribe();
      personalizedReadingHubSubject.unsubscribe();
      stickyBannerBottomSubject.unsubscribe();
    };
  }, [handleBlueconicEvent]);
};

export default useBlueconicEvent;
